document.addEventListener('DOMContentLoaded', function() {
    const anchorLinks = document.querySelectorAll(".anchor-link");

    anchorLinks.forEach(function(link) {
		let anchorID = "";
		if (link.classList.contains("anchor-section")) {
			anchorID = link.id;
		} else {
			anchorID = link.textContent.trim().replace(/\s+/g, "");
			anchorID = anchorID.replace(/^[^a-zA-Z]+/, "");
		}

        if (anchorID) {
			if (!link.classList.contains("anchor-section")) {
				link.id = anchorID;
			}

            const anchorLink = window.location.href.split('#')[0] + "#" + anchorID;

            link.onclick = function(event) {
                event.preventDefault();
                event.stopPropagation();
                navigator.clipboard.writeText(anchorLink).then(function() {
                    window.location.hash = anchorID;

                    const targetElement = document.getElementById(anchorID);
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                    }

					bootstrap.Toast.getOrCreateInstance(document.querySelector("#copyToast")).show()
                }).catch(function(error) {
                    console.error('Error copying the link to clipboard: ', error);
                });
            };
        }
    });

    const initialHash = window.location.hash;
    if (initialHash) {
        const initialElement = document.querySelector(initialHash);
        if (initialElement) {
            initialElement.scrollIntoView({ behavior: 'smooth' });
        }
    }
});
